// USD formatter shared by the report screens. `cents: false` drops the
// fraction for chart axes and compact totals ("$1,250" instead of "$1,250.00").

const withCents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const wholeDollars = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatCurrency = (amount, { cents = true } = {}) =>
  (cents ? withCents : wholeDollars).format(amount || 0);
